import { useIFCConfigContext } from '../context/index.tsx';

export const useIFCEditField = ({ fieldId }: { fieldId?: string | null }) => {
	const { ifcConfig } = useIFCConfigContext();

	if (fieldId == null) {
		return;
	}

	const onUpdate = () => {
		ifcConfig?.onUpdate({
			fieldId,
		});
	};

	return onUpdate;
};
